module.exports = "<p class=\"<%= gwTileHeaderIcon %>\">\r\n    <i class=\"fa\" ng-class=\"icon\"></i>\r\n</p>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/platform/widgets/tiles/tileLayout/HeaderIcon/tile-header-icon.html
// module id = 600
// module chunks = 0